<template>
  <div
    class="slider-container"
    @mousedown="startSlide"
    @touchstart="startSlide"
    @mouseup="endSlide"
    @mouseleave="endSlide"
    @touchend="endSlide"
  >
    <!-- Black fill bar -->
    <div
      class="slider-fill"
      :style="{ width: `${sliderValue}%` }"
    ></div>

    <!-- Text displayed on the slider -->
    <span 
    class="slider-text"
    :style="{ color: sliderValue > 50 ? 'white' : 'black' }"
    >
    Slide to unlock and start calendar upload</span>
  </div>
</template>

<script>
export default {
  name: "SlidingButton",
  data() {
    return {
      isSliding: false,
      sliderValue: 10, // Slider position (percentage)
    };
  },
  methods: {
    startSlide(event) {
      console.log(event); // Log `event` for debugging
      this.isSliding = true;
      document.addEventListener("mousemove", this.handleSlide);
      document.addEventListener("touchmove", this.handleSlide);
    },
    endSlide() {
      if (this.isSliding) {
        this.isSliding = false;
        document.removeEventListener("mousemove", this.handleSlide);
        document.removeEventListener("touchmove", this.handleSlide);

        // Check if the slider has reached the end
        if (this.sliderValue >= 90) {
          this.activateAction();
        } else {
          // Reset the slider if not completed
          this.sliderValue = 10;
        }
      }
    },
    handleSlide(event) {
  if (!this.isSliding) return;
    const sliderContainer = this.$el.getBoundingClientRect();
    const clientX = event.touches ? event.touches[0].clientX : event.clientX;
    let newSliderValue = ((clientX - sliderContainer.left) / sliderContainer.width) * 100;

  // Clamp the slider value between 0 and 100
  this.sliderValue = Math.min(Math.max(newSliderValue, 0), 100);
},
    activateAction() {
      console.log("Slider completed! Activating action...");
      // Trigger the desired action when the slider reaches the end
      // alert("Action activated! Calendar upload started.");
      this.$emit('action-completed');
    },
  },
};
</script>

<style scoped>
/* Slider container styling */
.slider-container {
  position: relative;
  width: 350px;
  height: 40px;
  margin-left: 40px;
  background-color: white;
  border: 1px solid black;
  display: flex;
  align-items: center;
  justify-content: center;
  overflow: hidden;
  user-select: none;
  cursor: pointer;
}

/* Black fill bar that moves with the slider */
.slider-fill {
  position: absolute;
  top: 0;
  left: 0;
  height: 100%;
  background-color: black;
  z-index: 1;
  transition: width 0.1s;
}

/* Slider text */
.slider-text {
  position: absolute;
  z-index: 2;
  color: black;
  font-size: 16px;
  pointer-events: none;
}
</style>
